import { Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";

import Navbar from "./pages/Navbar";
import Footer from "./pages/Footer";
import WhatsAppFloat from "./pages/Whatsappfloat";
import CustomCursor from "./pages/CustomCursor";
import { useCustomCursor } from "./pages/Usecustomcursor";

import PageTransition from "./pages/Pagetransition";

import {
  SectionLabel,
  SectionTitle,
  RevealBox,
  Divider,
} from "./pages/Sectioncomponents";

// Pages
import HomePage from "./pages/HomePage";
import ProductosPage from "./pages/Productospage";
import ContactoPage from "./pages/Contactpage";
import UbicacionPage from "./pages/Ubicacionpage";
import AdminProductos from "./pages/AdminProductos";
import Politicas from "./pages/Politicas";

/* ───────────────── PLACEHOLDER PAGE ───────────────── */
function PlaceholderPage({
  label,
  title,
  light = false,
}) {
  return (
    <PageTransition>
      <div
        style={{
          minHeight: "100vh",
          paddingTop: "10rem",
          paddingBottom: "6rem",
          paddingLeft: "2rem",
          paddingRight: "2rem",
          background: light ? "#f9f5ef" : "#1a1814",
        }}
      >
        <div
          style={{
            maxWidth: 800,
            margin: "0 auto",
          }}
        >
          <RevealBox>
            <SectionLabel dark={light}>
              {label}
            </SectionLabel>
          </RevealBox>

          <RevealBox delay={0.1}>
            <SectionTitle dark={light}>
              {title}
            </SectionTitle>
          </RevealBox>

          <RevealBox delay={0.2}>
            <Divider dark={light} />
          </RevealBox>

          <RevealBox delay={0.3}>
            <p
              style={{
                fontFamily: "'Jost', sans-serif",
                fontWeight: 300,
                lineHeight: 1.9,
                color: light
                  ? "#6b6257"
                  : "rgba(249,245,239,0.65)",
              }}
            >
              Sección en construcción. Escribinos por
              WhatsApp para más información.
            </p>
          </RevealBox>
        </div>
      </div>
    </PageTransition>
  );
}

/* ───────────────── APP SHELL ───────────────── */
function AppShell() {
  useCustomCursor();

  const location = useLocation();

  return (
    <>
      <Navbar />

      <main>
        <AnimatePresence mode="wait">
          <Routes
            location={location}
            key={location.pathname}
          >
            {/* HOME */}
            <Route
              path="/"
              element={<HomePage />}
            />


            {/* PAGES */}
            <Route
              path="/productos"
              element={<ProductosPage />}
            />



            {/* PAGES */}
            <Route
              path="/politicas"
              element={<Politicas />}
            />

            <Route
              path="/contacto"
              element={<ContactoPage />}
            />

            <Route
              path="/ubicacion"
              element={<UbicacionPage />}
            />

            {/* PLACEHOLDER */}
            <Route
              path="/nosotros"
              element={
               <HomePage/>
              }
            />

            <Route
              path="/adminProductos"
              element={
                <AdminProductos/>
              }
            />

            {/* 404 */}
            <Route
              path="*"
              element={
                <PlaceholderPage
                  label="Error 404"
                  title="Página no encontrada"
                />
              }
            />
          </Routes>
        </AnimatePresence>
      </main>

      <Footer />

      <WhatsAppFloat />
    </>
  );
}

/* ───────────────── ROOT APP ───────────────── */
export default function App() {
  return (
    <>
      <CustomCursor />

      <AppShell />

      <style>{`
        *,
        *::before,
        *::after {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }

        html {
          scroll-behavior: smooth;
        }

        body {
          font-family: 'Jost', sans-serif;
          background: #1a1814;
          color: #f9f5ef;
          overflow-x: hidden;
          cursor: none;
        }

        a,
        button {
          cursor: none;
        }
      `}</style>
    </>
  );
}